export default "__VITE_ASSET__C13CQ$Z2__"